import {
  Box,
  Button,
  Flex,
  FormControl,
  FormLabel,
  Switch,
  useColorModeValue,
  useDisclosure,
} from '@chakra-ui/react';
import { useAppDispatch, useAppSelector } from '../../../core/hooks/storeHooks';
import { calculateSectionHeightHelper } from '../../utils';
import { useTranslation } from 'react-i18next';
import SaveDiscardChangesDialog from '../../../app/components/dialogs/SaveDiscardChangesDialog';
import { useState } from 'react';
import { tabSharedWorker } from '../../../core/sharedWorker/sharedWorkerManager';
import { SharedWorkerMessage } from '../../../core/sharedWorker/types';
import {
  redoSheets,
  undoSheets,
} from '../../../sheet/redux/sagas/history/historyActions';
import { startCreateNewSheet } from '../../../sheet/redux/sagas/commands/compositeCommandsActions';

const BottomSection = () => {
  const changesCount = useAppSelector(
    (state) => state.sheetsManager.unSavedHistory.length
  );
  const isManualSave = useAppSelector(
    (state) => state.sheetsManager.isManualSave
  );
  const userId: string = useAppSelector((state) => state.auth.user.id);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [disableManualModeOnDiscard, toggleDisableManualMode] = useState(false);

  const sheetsIdToName = useAppSelector(
    (state) => state.sheetsManager.entityIdToNameMap.sheetsIdToName
  );

  const backgroundColor = useColorModeValue('#fff', '#1a202c');
  const bottomSection = useAppSelector((state) => state.sections.bottomSection);
  const totalHeight = calculateSectionHeightHelper(bottomSection);
  const { t } = useTranslation();

  const dispatch = useAppDispatch();
  const addWindow = () => {
    dispatch(startCreateNewSheet({}));
    // dispatch(addNewSheetToGroup());
    // dispatch(
    //   handleSheetOperations({
    //     type: SheetCommandType.CreateSheet,
    //     sheet: createSheet(userId, getUniqueEntityName(sheetsIdToName)),
    //   })
    // );
  };

  const undo = () => dispatch(undoSheets());
  const redo = () => dispatch(redoSheets());

  const enableManualMode = () => {
    tabSharedWorker.port.postMessage({
      type: SharedWorkerMessage.SyncManualSaveToggle,
      userId,
      isManualSave: true,
    });
    // dispatch(enableManualSave());
    // saveManualModeToggle(userId);
  };
  const saveChanges = (disableManualMode?: boolean) => {};
  // dispatch(saveManualModeChanges(disableManualMode));
  const discardChanges = (disableManualMode?: boolean) => {};
  // dispatch(discardManualModeChanges(disableManualMode));

  const openSaveDiscardModal = (disable = false) => {
    if (changesCount > 0) {
      toggleDisableManualMode(disable);
      onOpen();
      return;
    }

    if (disable) discardChanges(true);
    // tabSharedWorker.port.postMessage({
    //   type: SharedWorkerMessage.SyncManualSaveToggle,
    //   userId,
    //   isManualSave: false,
    // });
  };

  const toggleAutoMode = () => {
    if (isManualSave) openSaveDiscardModal(true);
    else enableManualMode();
  };

  return (
    <Box
      h={totalHeight}
      w={'100%'}
      boxShadow="dark-lg"
      position="fixed"
      bottom={0}
      zIndex={100}
      background={backgroundColor}
      px="5"
      borderRadius="10px"
    >
      <SaveDiscardChangesDialog
        isOpen={isOpen}
        onClose={onClose}
        disableManualMode={disableManualModeOnDiscard}
        saveChanges={saveChanges}
        discardChanges={discardChanges}
      />
      <Flex>
        <FormControl display="flex" alignItems="center">
          <FormLabel htmlFor="sheets-auto-save" mb="0">
            Sheets Auto Save
          </FormLabel>
          <Switch
            id="sheets-auto-save"
            isChecked={!isManualSave}
            onChange={toggleAutoMode}
          />
        </FormControl>

        <Flex>
          <Button size="sm" borderRadius={20} onClick={addWindow}>
            {t('controls.add-window')}
          </Button>
          <Button size="sm" borderRadius={20} onClick={undo}>
            undo
          </Button>
          <Button size="sm" borderRadius={20} onClick={redo}>
            redo
          </Button>

          {/* <Button
            size="sm"
            borderRadius={20}
            onClick={() => {
              if (isManualSave) openSaveDiscardModal(true);
              else enableManualMode();
            }}
          >
            {isManualSave ? 'Disable' : 'Enable'} Manual Mode
          </Button> */}

          {/* <Button
        size="sm"
        borderRadius={20}
        onClick={() => openSaveDiscardModal(true)}
      >
        Disable Manual Mode
      </Button> */}

          <Button size="sm" borderRadius={20} onClick={() => saveChanges()}>
            Save Changes
          </Button>

          <Button
            size="sm"
            borderRadius={20}
            onClick={() => openSaveDiscardModal()}
          >
            Discard Changes
          </Button>
        </Flex>
      </Flex>

      {/* <Spacer /> */}
    </Box>
  );
};

export default BottomSection;
